import { getCloudflareUploadUrls } from "api/apiCloudflare";
import { uploadFileWithProgress } from "utils/helpers/featchFiles/uploadFileWithProgress";

export const uploadImageToCloudflare = async (
    file: File,
    keyPrefix = "editor-images",
): Promise<string | null> => {
    try {
        const uploadConfigs = await getCloudflareUploadUrls(
            [
                {
                    fileName: file.name,
                    contentType: file.type || "application/octet-stream",
                    fileSize: file.size,
                },
            ],
            {},
            { keyPrefix },
        );

        const uploadConfig = uploadConfigs?.[0];
        if (!uploadConfig) return null;

        const uploaded = await uploadFileWithProgress(file, uploadConfig);
        if (!uploaded.success || !uploaded.config?.publicUrl) return null;

        return String(uploaded.config.publicUrl);
    } catch (error) {
        console.error(error);
        return null;
    }
};
